import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {ContactSummary} from '../../../../../api';
import {TableModule} from 'primeng/table';
import {TranslatePipe} from '@ngx-translate/core';
import {ElciaButton} from '../../../../components/buttons/button/button';

@Component({
  selector: 'elcia-contact-grid',
  imports: [
    TableModule,
    TranslatePipe,
    ElciaButton
  ],
  templateUrl: './contact-grid.html',
  styleUrl: './contact-grid.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactGrid {
  contacts = input.required<ContactSummary[]>();
  isLoading = input.required<boolean>();
  onDelete = output<ContactSummary>();
  contactSelected = output<ContactSummary>();

  onRowSelect(contact: ContactSummary): void {
    this.contactSelected.emit(contact);
  }

  delete(event: Event, contact: ContactSummary): void {
    event.stopPropagation();
    this.onDelete.emit(contact);
  }
}
